// Columnas del head por defecto
export const defaultFields = () => {
    return [
        {
            key: 'product',
            label: 'Producto',
            sortable: true
        },
        {
            key: 'synonymous',
            label: 'Sinónimos',
            sortable: true
        },
        {
            key: 'actions',
            label: 'Acciones',
            sortable: false
        },
    ];
}

// Columnas del head por defecto para el historial de trazabilidad por producto
export const defaultFieldsDetailsTraceableTable = () => {
    return [
        {
            key: 'action',
            label: 'Acción',
            sortable: true,
            thStyle: { width: "10%", maxWidth: "10%" }
        },
        {
            key: 'type',
            label: 'Tipo',
            sortable: true,
            thStyle: { width: "10%", maxWidth: "10%" }
        },
        {
            key: 'comments',
            label: 'Comentarios',
            sortable: true,
            thStyle: { width: "50%", maxWidth: "50%" }
        },
        {
            key: 'user',
            label: 'Usuario',
            sortable: true,
            thStyle: { width: "15%", maxWidth: "15%" }
        },
        {
            key: 'created_at',
            label: 'Fecha',
            sortable: true,
            thStyle: { width: "15%", maxWidth: "15%" }
        },
    ];
}

// Configuración de la tabla (head, body)
export const dataConfigTable = () => {
    return {
        fields: defaultFields(),
        items: [],
        data: {
            total: 0,
            page: 1,
            per_page: 10
        }
    }
}

// Filtros y paginación
export const defaultParamsFilter = () => {
    return {
        // Datos importantes
        product: '',
        company_id: null, // Empresa
    };
};

export const defaultDefaultTableTraceable = () => {
    return {
        fields: defaultFieldsDetailsTraceableTable(),
        data: {
            total: 0,
            page: 1,
            per_page: 10,
            current_page: 1
        }
    }
}

// Modal detalles de la trazabilidad
export const defaultDataModalTraceable = () => {
    return {
        assignId: null,
        company_id: null,
        product_id: null,
        traceableItems: [],
        table: defaultDefaultTableTraceable(),
        loading: false,
        product: null
    };
};

export const defaultTraceable = () => {
    return {
        type: null,
        comments: '',
        action: 'NOTA'
    };
};

export const defaultFilterTable = () => {
    return {
        show_form: false,
        type: null,
        action: null
    };
};

export default {
    loadingDataTable: false,
    tableConfig: dataConfigTable(),
    filter: defaultParamsFilter(),
    dataModalTraceable: defaultDataModalTraceable(),
    actionToTraceablePQ: {
        action: null, // ASSIGNMENT: asignación/desasignación, USE: uso/no-uso, NOTA: comentarios
        data: null
    },
    traceable: defaultTraceable(),
    filter_table: defaultFilterTable()
}
